/*
  Product page — sections/shoes-egy-product.liquid.

  Gallery (thumbs, counter, zoom), sizes (saved size, Add to bag state),
  quantity, the colours of the model (loaded once, then switched in place
  without a reload), pairs per model under "More from" (loaded on view) and
  the mobile buy bar. Everything hangs off one listener per root, so the
  parts swapped in by a colour change need no re-binding.
*/
(function () {
  var SIZE_KEY = 'shoesEgySize';

  function getSaved() { try { return localStorage.getItem(SIZE_KEY); } catch (e) { return null; } }
  function setSaved(v) { try { localStorage.setItem(SIZE_KEY, v); } catch (e) {} }

  function init(root) {
    var sectionId = root.getAttribute('data-section-id');
    var cache = {};

    // ---------------------------------------------------------------- gallery
    function showImage(thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var img = gallery.querySelector('.shoes-pdp__main img');
      img.removeAttribute('srcset');
      img.src = thumb.getAttribute('data-src');
      img.setAttribute('srcset', thumb.getAttribute('data-srcset'));
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        if (t === thumb) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var count = gallery.querySelector('[data-count-current]');
      if (count) count.textContent = thumb.getAttribute('data-thumb');
    }

    var layer = root.querySelector('[data-zoom-layer]');
    function openZoom() {
      var current = root.querySelector('[data-thumb][aria-current="true"]');
      var main = root.querySelector('.shoes-pdp__main img');
      if (!main) return;
      var src = current ? current.getAttribute('data-zoom-src') : main.currentSrc || main.src;
      layer.querySelector('[data-zoom-image]').src = src;
      layer.hidden = false;
      document.documentElement.classList.add('shoes-pdp-zoomed');
      layer.querySelector('[data-zoom-close]').focus();
    }
    function closeZoom() {
      layer.hidden = true;
      document.documentElement.classList.remove('shoes-pdp-zoomed');
      var main = root.querySelector('[data-zoom]');
      if (main) main.focus();
    }

    // ---------------------------------------------------------------- sizes
    function sizeInputs() { return root.querySelectorAll('[data-sizes] input[type="radio"]'); }

    function isSoldOut(input) { return input.getAttribute('data-available') === 'false'; }

    function showSoldOut(on) {
      var note = root.querySelector('[data-soldout-note]');
      if (note) note.hidden = !on;
    }

    // A sold-out size can be picked, but only to be told so: the note shows,
    // Add to bag reads Sold out and stays shut, Buy it now is locked.
    function applySize(input, remember) {
      var form = root.querySelector('[data-pdp-part="buy"]');
      if (!form || !input) return;
      var soldOut = isSoldOut(input);
      form.querySelector('[data-variant-input]').value = input.getAttribute('data-variant-id');
      var add = form.querySelector('[data-add]');
      var now = form.querySelector('[data-buy-now]');
      if (soldOut) {
        add.setAttribute('aria-disabled', 'true');
        add.setAttribute('data-sold-out', '');
        add.querySelector('[data-add-label]').textContent = 'Sold out';
        if (now) now.classList.add('is-locked');
      } else {
        add.removeAttribute('aria-disabled');
        add.removeAttribute('data-sold-out');
        add.querySelector('[data-add-label]').textContent = 'Add to bag';
        if (now) now.classList.remove('is-locked');
      }
      showSoldOut(soldOut);
      root.querySelectorAll('[data-price]:not(input)').forEach(function (p) { p.textContent = input.getAttribute('data-price'); });
      if (remember) setSaved(input.value);
      showSaved();
      if (!soldOut) document.dispatchEvent(new CustomEvent('shoes:size-changed', { detail: { size: input.value } }));
    }

    function showSaved() {
      var line = root.querySelector('[data-saved-size]');
      if (!line) return;
      var saved = getSaved();
      if (saved) {
        line.textContent = 'Your size ' + saved + ' is saved';
        var ar = document.createElement('span');
        ar.className = 'shoes-ar shoes-ar--sm';
        ar.lang = 'ar'; ar.dir = 'rtl';
        ar.textContent = 'مقاسك ' + saved + ' متسجل عندنا';
        line.appendChild(ar);
        line.hidden = false;
      } else {
        line.hidden = true;
      }
    }

    // 'ok' when the size was picked, 'sold-out' when this product has it but
    // it is sold out (left unpicked), false when it does not carry it.
    function selectSize(value) {
      if (!value) return false;
      var match = null;
      sizeInputs().forEach(function (i) { if (i.value === value) match = i; });
      if (!match) return false;
      if (isSoldOut(match)) return 'sold-out';
      match.checked = true;
      applySize(match, false);
      return 'ok';
    }

    function restoreSize(preferred) {
      var checked = root.querySelector('[data-sizes] input:checked');
      if (checked) { applySize(checked, false); return; }
      showSoldOut(false);
      var result = selectSize(preferred);
      if (result !== 'ok') {
        var saved = selectSize(getSaved());
        if (result === 'sold-out' || saved === 'sold-out') showSoldOut(saved !== 'ok');
      }
      showSaved();
    }

    // ---------------------------------------------------------------- colours
    var swatchBox = root.querySelector('[data-swatches]');

    function markCurrentSwatch() {
      if (!swatchBox) return;
      var handle = root.getAttribute('data-handle');
      swatchBox.querySelectorAll('[data-swatch]').forEach(function (a) {
        if (a.getAttribute('data-handle') === handle) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    function loadSwatches() {
      if (!swatchBox) return;
      var base = swatchBox.getAttribute('data-swatches-url');
      fetch(base + '?section_id=shoes-egy-product-swatches')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var data = doc.querySelector('[data-swatch-data]');
          if (!data) return;
          var total = parseInt(data.getAttribute('data-count'), 10) || 0;
          if (total < 2) return;
          var links = Array.prototype.slice.call(data.querySelectorAll('a[data-handle]'));
          var handle = root.getAttribute('data-handle');
          links.sort(function (a, b) {
            return (b.getAttribute('data-handle') === handle) - (a.getAttribute('data-handle') === handle);
          });
          var list = swatchBox.querySelector('[data-swatch-list]');
          list.innerHTML = '';
          links.slice(0, 8).forEach(function (a) {
            var li = document.createElement('li');
            a.className = 'shoes-pdp__swatch';
            a.setAttribute('data-swatch', '');
            a.setAttribute('aria-label', a.getAttribute('data-colour'));
            li.appendChild(a);
            list.appendChild(li);
          });
          if (total > 8) {
            var li = document.createElement('li');
            var more = document.createElement('a');
            more.className = 'shoes-pdp__swatch shoes-pdp__swatch--more';
            more.href = base;
            more.textContent = '+' + (total - 8);
            more.setAttribute('aria-label', (total - 8) + ' more colours');
            li.appendChild(more);
            list.appendChild(li);
          }
          swatchBox.querySelector('[data-swatch-count]').textContent = total;
          markCurrentSwatch();
          swatchBox.hidden = false;
        })
        .catch(function () {});
    }

    function fetchProduct(url) {
      if (!cache[url]) {
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        cache[url] = fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
          .catch(function (e) { delete cache[url]; throw e; });
      }
      return cache[url];
    }

    function swapTo(url, push) {
      var keepSize = (root.querySelector('[data-sizes] input:checked') || {}).value;
      return fetchProduct(url).then(function (doc) {
        var next = doc.querySelector('[data-pdp]');
        if (!next) throw new Error('no section');
        root.querySelectorAll('[data-pdp-part]').forEach(function (part) {
          var key = part.getAttribute('data-pdp-part');
          var fresh = next.querySelector('[data-pdp-part="' + key + '"]');
          if (fresh) part.replaceWith(document.importNode(fresh, true));
        });
        root.setAttribute('data-handle', next.getAttribute('data-handle'));
        root.setAttribute('data-url', next.getAttribute('data-url'));
        var ld = root.querySelector('script[type="application/ld+json"]');
        var nextLd = next.querySelector('script[type="application/ld+json"]');
        if (ld && nextLd) ld.textContent = nextLd.textContent;
        var title = doc.querySelector('title');
        if (title && title.textContent.trim()) document.title = title.textContent.trim();
        if (push) history.pushState({ shoesPdp: true, url: url }, '', url);
        markCurrentSwatch();
        restoreSize(keepSize);
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) window.Shopify.PaymentButton.init();
        watchBuy();
        document.dispatchEvent(new CustomEvent('shoes:product-changed', { detail: { handle: next.getAttribute('data-handle') } }));
      });
    }

    window.addEventListener('popstate', function () {
      var path = window.location.pathname;
      if (path.indexOf('/products/') === -1) return;
      swapTo(path + window.location.search, false).catch(function () { window.location.reload(); });
    });
    history.replaceState({ shoesPdp: true, url: window.location.pathname + window.location.search }, '');

    // ---------------------------------------------------------------- more from (counts on view)
    function loadModelCounts(box) {
      var url = box.getAttribute('data-models-url');
      function page(n) {
        return fetch(url + '?section_id=shoes-egy-brand-models&page=' + n)
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-brand-models]');
            if (!el) throw new Error('no data');
            return JSON.parse(el.textContent);
          });
      }
      page(1).then(function (first) {
        var rest = [];
        for (var n = 2; n <= first.pages; n++) rest.push(page(n));
        return Promise.all(rest).then(function (more) {
          return more.reduce(function (all, d) { return all.concat(d.tags); }, first.tags);
        });
      }).then(function (tags) {
        var counts = {};
        tags.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });
        var chips = Array.prototype.slice.call(box.querySelectorAll('[data-tags]'));
        var list = chips.length ? chips[0].closest('ul') : null;
        chips.map(function (chip) {
          var n = counts[chip.getAttribute('data-tags')] || 0;
          chip.querySelector('[data-count]').textContent = '(' + n + ')';
          return { li: chip.closest('li'), n: n, name: chip.textContent };
        }).sort(function (a, b) { return b.n - a.n || a.name.localeCompare(b.name); })
          .forEach(function (it) { if (it.n === 0) it.li.remove(); else list.appendChild(it.li); });
      }).catch(function () {});
    }

    var moreBox = root.querySelector('[data-more-models]');
    if (moreBox && 'IntersectionObserver' in window) {
      var moreObs = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          moreObs.disconnect();
          loadModelCounts(moreBox);
        }
      }, { rootMargin: '300px' });
      moreObs.observe(moreBox);
    }

    // ---------------------------------------------------------------- mobile buy bar
    var bar = root.querySelector('[data-sticky-bar]');
    var buyObs = null;
    function watchBuy() {
      if (!bar || !('IntersectionObserver' in window)) return;
      if (buyObs) buyObs.disconnect();
      var add = root.querySelector('[data-add]');
      if (!add) return;
      buyObs = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Show only once the real button has scrolled up out of view.
        var gone = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.hidden = !gone;
        document.documentElement.classList.toggle('shoes-pdp-bar-on', gone);
      });
      buyObs.observe(add);
    }

    // ---------------------------------------------------------------- events
    root.addEventListener('click', function (e) {
      var t = e.target;
      var thumb = t.closest('[data-thumb]');
      if (thumb) { showImage(thumb); return; }
      if (t.closest('[data-zoom]')) { openZoom(); return; }
      if (t.closest('[data-zoom-close]') || t === layer || t.closest('[data-zoom-image]')) { closeZoom(); return; }

      var guide = t.closest('[data-open-size-guide]');
      if (guide) {
        var panel = root.querySelector('[data-size-guide]');
        panel.open = true;
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        panel.querySelector('summary').focus({ preventScroll: true });
        return;
      }

      var qty = t.closest('[data-qty]');
      if (qty) {
        var input = root.querySelector('[data-qty-input]');
        var v = (parseInt(input.value, 10) || 1) + parseInt(qty.getAttribute('data-qty'), 10);
        input.value = Math.max(1, v);
        return;
      }

      var add = t.closest('[data-add]');
      if (add && add.hasAttribute('data-sold-out')) {
        e.preventDefault();
        showSoldOut(true);
        return;
      }
      if (add && add.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        var grid = root.querySelector('[data-sizes]');
        if (grid) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = grid.querySelector('input[data-available="true"]');
          if (first) first.focus({ preventScroll: true });
        }
        return;
      }

      if (t.closest('[data-bar-buy]')) {
        var realAdd = root.querySelector('[data-add]');
        if (realAdd.getAttribute('aria-disabled') === 'true') {
          if (realAdd.hasAttribute('data-sold-out')) showSoldOut(true);
          root.querySelector('[data-sizes]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          realAdd.click();
        }
        return;
      }

      var swatch = t.closest('[data-swatch]');
      if (swatch && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        if (swatch.getAttribute('aria-current') === 'true') { e.preventDefault(); return; }
        e.preventDefault();
        var href = swatch.getAttribute('href');
        root.classList.add('is-switching');
        swapTo(href, true)
          .catch(function () { window.location.href = href; })
          .then(function () { root.classList.remove('is-switching'); });
      }
    });

    // Warm the cache so a click swaps instantly.
    root.addEventListener('pointerover', function (e) {
      var swatch = e.target.closest && e.target.closest('[data-swatch]');
      if (swatch && swatch.getAttribute('aria-current') !== 'true') fetchProduct(swatch.getAttribute('href')).catch(function () {});
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sizes] input[type="radio"]')) applySize(e.target, true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && layer && !layer.hidden) closeZoom();
    });

    restoreSize(null);
    loadSwatches();
    watchBuy();
  }

  document.querySelectorAll('[data-pdp]').forEach(init);
})();
